import { Tooltip as UiTooltip, TooltipTrigger } from '@Pages/pageRuntime/components/ui/Tooltip';
import { TooltipContent } from '@Pages/pageRuntime/components/ui/TooltipContent';
import type React from 'react';

type TooltipProps = {
  /**
   * Element that receives the tooltip.
   */
  trigger: React.ReactNode;

  /**
   * Tooltip text or content.
   */
  content: React.ReactNode;

  /**
   * Preferred side for the tooltip.
   */
  side?: 'top' | 'right' | 'bottom' | 'left';
};

/**
 * A small hover/focus hint attached to an element. Use for brief clarifications, not
 * essential instructions.
 *
 * @example
 * <Sdk.Components.Tooltip trigger={<span>?</span>} content="This value updates nightly." />
 */
export function Tooltip({ trigger, content, side = 'top' }: TooltipProps) {
  return (
    <UiTooltip>
      <TooltipTrigger asChild>{trigger}</TooltipTrigger>
      <TooltipContent side={side}>{content}</TooltipContent>
    </UiTooltip>
  );
}
